import React from 'react';
import AdultAvatar from './AdultAvatar';
import BabyAvatar from './BabyAvatar';
import ChildAvatar from './ChildAvatar';
import { AgeSegmentRoomState } from '../../../../../types/booking/BookingTypes';

interface BookingRoomAvatarProps {
    ageSegment: AgeSegmentRoomState;
}

const BookingRoomAvatar = (props: BookingRoomAvatarProps) => {
    const { ageSegment } = props;
    if (ageSegment === AgeSegmentRoomState.BABY) {
        return <BabyAvatar />;
    }
    if (ageSegment === AgeSegmentRoomState.CHILD) {
        return <ChildAvatar />;
    }

    return <AdultAvatar />;
};

export default BookingRoomAvatar;
